import React from 'react';
import { getImageStyle } from './ImagePositionEditor';

export function blogImageUrl(src) {
  return src?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL || ''}${src}` : src;
}

export default function BlogImage({ src, position, alt, className = '', onLoad }) {
  return <img src={blogImageUrl(src)} alt={alt} draggable={false} onLoad={onLoad} className={`w-full h-full ${className}`} style={getImageStyle(position)} />;
}
